export default __webpack_public_path__ + "static/media/studentLogin3.50aa98c4.gif";